import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#5A4632]/15 bg-[#F3EFEA] py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {MARQUEE_ITEMS.map((item) => (
              <span key={`${dup}-${item}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-xl italic text-[#5A4632]/75">{item}</span>
                <Asterisk className="h-4 w-4 shrink-0 text-[#B85D43]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
